module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdLogin"
  }, [_c('p', [_vm._v("正在跳转请稍后......")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ea85037","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/thirdLogin/thirdLogin.vue
// module id = 514
// module chunks = 1